export default __webpack_public_path__ + "static/media/earn_inactive.1a4efb6b.svg";